import { useState, useEffect, useRef } from "react";
import Sidebar from "../Sidebar/Sidebar";
import TokenHeader from "../TokenHeader/TokenHeader";
import TokenDashboard from "../TokenDashboard/TokenDashboard";
import "./Token.scss";
import DashboardHeader from "../DashboardHeader/DashboardHeader";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Notification from "../Dashboard/Notification/Notification";
import { useLocation } from "react-router-dom";

const Token = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search)

  const clientId = params.get("clientId")
  const { requiredTokens } = location.state || {};

  console.log('requiredTokens', requiredTokens)

  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const notificationRef = useRef(null)

  // const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_PUBLISHABLE_API_KEY}`);
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setIsNotificationOpen(false);
      }
    };
    
    if (isNotificationOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isNotificationOpen]);

  
  const handleNotificationOpen = () => {
    setIsNotificationOpen(true);
  }
  const handleNotificationClose = () => {
    setIsNotificationOpen(false);
  };

  return (
    <div className="dashboard-platform">
      {/* <TokenHeader /> */}
      <DashboardHeader heading='Tokens' handleNotificationOpen={handleNotificationOpen} />
      <Notification ref={notificationRef} handleNotificationClose={handleNotificationClose} isNotificationOpen={isNotificationOpen} />
      
      <div className="dashboard-container">
        <div className="inner-container">
          {/* <Elements stripe={stripePromise}> */}
          
            <TokenDashboard heading={"Tokens"} clientId={clientId} requiredTokens={requiredTokens} />
          {/* </Elements> */}
          <div className="bottom-anchor"></div>
        </div>
      </div>
    </div>
  );
};

export default Token;
